import React from 'react';
import { Copy, SystemText } from '@salesperformanceint/e4shared';

export const CompetencyRoleDescriptions = ({ descriptions }) => {
    const sorted = [...descriptions].reduce((all, c) => {
        const current = all.find(x => x.description === c.description);
        if (current) {
            current.roles = current.roles.concat([c.name]);
        } else {
            all = all.concat([{ description: c.description, roles: [c.name] }]);
        }

        return all;
    }, []);

    return (
        <>
            {sorted.length > 0 ? (
                sorted.map((d, i) => (
                    <div className="mb20" key={`desc-${i}`}>
                        <Copy value={d.description} />
                    </div>
                ))
            ) : (
                <span>{SystemText('Reviews/Components/CompetencyRaterRow/NoDescription')}</span>
            )}
        </>
    );
};

export default CompetencyRoleDescriptions;
